import {
  Bell,
  Calendar,
  CalendarX,
  CheckCircle,
  Mail,
  Ticket,
  UserPlus,
  UserMinus,
  Users,
  XCircle,
  Sparkles,
  MapPin,
  type LucideIcon,
} from "lucide-react"

type IconConfig = {
  icon: LucideIcon
  className: string
}

const DEFAULT_ICON: IconConfig = { icon: Bell, className: "text-primary" }

const NOTIFICATION_ICON_MAP: Record<string, IconConfig> = {
  event_invitation: { icon: Mail, className: "text-blue-500" },
  event_cancelled: { icon: CalendarX, className: "text-red-500" },
  event_updated: { icon: Calendar, className: "text-amber-500" },
  event_reminder_24h: { icon: Calendar, className: "text-primary" },
  event_reminder_1h: { icon: Calendar, className: "text-primary" },
  rsvp_confirmed: { icon: CheckCircle, className: "text-green-500" },
  rsvp_waitlisted: { icon: Users, className: "text-amber-500" },
  rsvp_promoted: { icon: Sparkles, className: "text-green-500" },
  rsvp_approved: { icon: CheckCircle, className: "text-green-500" },
  rsvp_rejected: { icon: XCircle, className: "text-red-500" },
  rsvp_cancelled: { icon: UserMinus, className: "text-muted-foreground" },
  new_rsvp: { icon: UserPlus, className: "text-primary" },
  invitation_accepted: { icon: CheckCircle, className: "text-green-500" },
  ticket_created: { icon: Ticket, className: "text-primary" },
  ticket_minted: { icon: Sparkles, className: "text-violet-500" },
  check_in_confirmed: { icon: MapPin, className: "text-green-500" },
  session_rsvp_confirmed: { icon: CheckCircle, className: "text-green-500" },
  session_cancelled: { icon: CalendarX, className: "text-red-500" },
  session_deleted: { icon: CalendarX, className: "text-red-500" },
  community_event_new_rsvp: { icon: UserPlus, className: "text-primary" },
  community_event_rsvp_cancelled: { icon: UserMinus, className: "text-muted-foreground" },
  community_event_cancelled: { icon: CalendarX, className: "text-red-500" },
  community_event_checked_in: { icon: MapPin, className: "text-green-500" },
  collaborator_added: { icon: Users, className: "text-primary" },
  collaborator_removed: { icon: UserMinus, className: "text-muted-foreground" },
  removed_from_event: { icon: XCircle, className: "text-red-500" },
}

function getNotificationIcon(type: string): IconConfig {
  return NOTIFICATION_ICON_MAP[type] ?? DEFAULT_ICON
}

export function NotificationTypeIcon({ type, className = "w-4 h-4 shrink-0" }: { type: string; className?: string }) {
  const { icon: Icon, className: colorClass } = getNotificationIcon(type)
  return <Icon className={`${className} ${colorClass}`} aria-hidden />
}
